/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.CancellationReason_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.CancellationReason domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum CancellationReason_ {
   /// <summary>
   ///    (unknown)
   /// </summary>
   Unknown = 0,
   /// <summary>
   ///   Found an alternative we prefer (FA)
   /// </summary>
   FoundAlternative = 4,
   /// <summary>
   ///   Had trouble logging in or accessing the product (LOT)
   /// </summary>
   LogOnTrouble = 5,
   /// <summary>
   ///   Experienced technical issues (e.g., bugs, crashes, long loading times, or device incompatibility) (TI)
   /// </summary>
   TechIssues = 6,
   /// <summary>
   ///   Currently unable to afford the product (UTA)
   /// </summary>
   UnableToAfford = 7,
   /// <summary>
   ///   Didn't feel the product was worth the price (PNWP)
   /// </summary>
   ProductNotWorthPrice = 8,
   /// <summary>
   ///   The product is too advanced for my child/student (PTA)
   /// </summary>
   ProductTooAdvanced = 9,
   /// <summary>
   ///   The product is not advanced enough for my child/student (PTE)
   /// </summary>
   ProductTooEasy = 10,
   /// <summary>
   ///   Purchased to support the student representative, but we are no longer interested (NLI)
   /// </summary>
   NoLongerInterested = 11
}

export const CancellationReasons: CancellationReason[] = [
   {
      code: CancellationReason_.Unknown,
      literal: 'Unknown',
      description: '',
      shortDescription: 'unknown',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.FoundAlternative,
      literal: 'FoundAlternative',
      description: 'Found an alternative we prefer',
      shortDescription: 'FA',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.LogOnTrouble,
      literal: 'LogOnTrouble',
      description: 'Had trouble logging in or accessing the product',
      shortDescription: 'LOT',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.TechIssues,
      literal: 'TechIssues',
      description: 'Experienced technical issues (e.g., bugs, crashes, long loading times, or device incompatibility)',
      shortDescription: 'TI',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.UnableToAfford,
      literal: 'UnableToAfford',
      description: 'Currently unable to afford the product',
      shortDescription: 'UTA',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.ProductNotWorthPrice,
      literal: 'ProductNotWorthPrice',
      description: 'Didn\'t feel the product was worth the price',
      shortDescription: 'PNWP',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.ProductTooAdvanced,
      literal: 'ProductTooAdvanced',
      description: 'The product is too advanced for my child/student',
      shortDescription: 'PTA',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.ProductTooEasy,
      literal: 'ProductTooEasy',
      description: 'The product is not advanced enough for my child/student',
      shortDescription: 'PTE',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.NoLongerInterested,
      literal: 'NoLongerInterested',
      description: 'Purchased to support the student representative, but we are no longer interested',
      shortDescription: 'NLI',
      listPriority: 0,

      typeName: "CancellationReason"
   }
]

export class CancellationReason implements IDomainModel {
   code: CancellationReason_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: CancellationReason_): CancellationReason {
      return CancellationReasons.find(d => d.code === code)
   }
}
